<template>
    <div>
        <div class="modal-boddy">
            <div class="modal-text center">
                <div class="text-center">
                    <span>Olá, fornecedor(a)! A empresa que você representa é: </span>
                    <b>ME</b>
                    <span>, </span>
                    <b>EPP</b>
                    <span> ou </span>
                    <b>MEI</b>
                    <span>?</span>
                </div>
            </div>
        </div>
        <div class="modal-actions__actions">
            <v-btn color="primary btn-nao" outline @click="escolherValor('N')">Não</v-btn>
            <v-btn color="primary btn-sim" outline @click="escolherValor('S')">Sim</v-btn>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CredenciamentoFornecedorTermosInfoEmpresa',
        props: {
            value: {
                required: true
            }
        },
        methods: {
            escolherValor(valorEscolhido) {
                this.value.isMeEppMei = valorEscolhido
                this.irProximoPasso()
            },
            irProximoPasso() {
                this.$emit('proximo')
            }
        }
    }
</script>